module.exports = __webpack_public_path__ + "img/flow-img3-1.47cb7028.png";